import * as React from "react";
import "./index.css";

const ModalBase = ({
  title,
  setIsOpen,
  children,
  onClose,
  className,
}) => {

  React.useEffect(() => {
    const onEscape = (e) => {
      if (e.key === "Escape") {
        setIsOpen && setIsOpen(false);
        onClose && onClose();
      }
    };

    document.addEventListener("keydown", onEscape);

    return () => document.removeEventListener("keydown", onEscape);
  }, []);

  return (
    <>
      <section
        title={title || "Overlay"}
        className={`modal-overlay requires-no-scroll`}
        onClick={(e) => {
          if (Array.from(e.target.classList).includes("modal-overlay")) {
            setIsOpen && setIsOpen(false);
            onClose && onClose();
          }
        }}
      >
        <section
          title={title || "Modal"}
          className={"modal-content modal-anim " + className}
        >
          {children}
        </section>
      </section>
    </>
  );
};

export default ModalBase;
